import { render, staticRenderFns } from "./ApiPicture.vue?vue&type=template&id=6095bacc&"
import script from "./ApiPicture.vue?vue&type=script&lang=js&"
export * from "./ApiPicture.vue?vue&type=script&lang=js&"
import style0 from "./ApiPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports